import * as React from "react";

interface ITickSVGProps {
    color?: string;
}

export const TickSVG = (props: ITickSVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={25.383} height={19.404} viewBox="0 0 25.383 19.404" {...props}>
        <path
            d="M9.351 18.4L1 10.053 3.355 7.7l6 5.979L22.028 1l2.355 2.372z"
            fill={props.color ? props.color : "#fff"}
            stroke={props.color ? props.color : "#fff"}
            strokeLinejoin="round"
            strokeMiterlimit={10}
            strokeWidth={2}
        />
    </svg>
);
